import React from 'react';
import ReactDom from 'react-dom';
import styled from 'styled-components';

import { Button, Icon } from '@roo/roo';

const Root = styled.div`
  width: 400px;
  height: 200px;
  background-color: #fff;
  top: 100px;
  position: fixed;
  right: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 #a2a4b3;
  z-index: 9999;
  .tip-box {
    padding: 20px;
  }
  .tip-icon {
    position: absolute;
    top: 50px;
    left: 30px;
    font-size: 34px;
  }
  .t-text {
    margin: 30px 0 0 64px;
    .t-header {
      font-size: 18px;
      font-weight: 500;
      line-height: 25px;
      height: 25px;
      color: #222;
    }
    .t-content {
      font-size: 14px;
      height: 19px;
      line-height: 19px;
      color: #666;
    }
  }
  .footer {
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
  .success{
    .tip-icon {
      color: #02BF80;
    }
    .t-text {
      .t-header {

      }
      .t-content {

      }
    }
  }
  .fail{
    .tip-icon {
      color: #FF1B2D;
    }
    .t-text {
      .t-header {

      }
      .t-content {

      }
    }
  }
`;

let timer = null;

export function ToastTipView(props) {
  const icons = { success: 'check-circle', fail: 'times-circle' };
  const { status = 'success', title = '保存成功', content = '已成功保存数据' } = props;
  return (
    <Root>
      <div className={`tip-box ${status}`}>
        <Icon name={icons[status]} className={`tip-icon icon-${status}`} />
        <div className="t-text">
          <p className="t-header">{title}</p>
          <p className="t-content">{content}</p>
        </div>
        <div className="footer">
          <Button
            onClick={() => {
              if (timer) {
                clearTimeout(timer);
              }
              try {
                ReactDom.unmountComponentAtNode(document.querySelector('#test-tip'));
              } catch (e) {
                //not
              }
            }}
          >
            我知道了
          </Button>
        </div>
      </div>
    </Root>
  );
}

export const toastTip = {
  open({ title, content, status }) {
    const node = document.body.querySelector('#test-tip');
    if (timer) {
      clearTimeout(timer);
      ReactDom.unmountComponentAtNode(node);
    }
    ReactDom.render(<ToastTipView title={title} content={content} status={status} />, node);
    timer = setTimeout(() => {
      ReactDom.unmountComponentAtNode(node);
    }, 3000);
  },
};
